import useReveal from "./useReveal";

// A content block: a left-rail marker label beside a body column.
// Reveals its contents with a staggered transition when scrolled into view.
export default function Block({ marker, bodyClassName = "", children }) {
  const [ref, visible] = useReveal();
  return (
    <section
      ref={ref}
      className={`wrap block reveal ${visible ? "is-visible" : ""}`}
    >
      <p className="marker">{marker}</p>
      <div className={`body ${bodyClassName}`.trim()}>{children}</div>
    </section>
  );
}
